module.exports = __webpack_public_path__ + "static/media/ocean.ddd4f58d.png";